import React from 'react';
import DynamicRoute from "./DynamicRoute";

function App() {
    return (
        <div>
            <DynamicRoute />
        </div>
    );
}

export default App;